module.exports = __webpack_public_path__ + "img/amex-1kpx.2e7f48ed.png";